/**
 * Color DICOMs (RGB) produce per-channel statistic arrays [R, G, B].
 * Use the red channel when displaying a single scalar value.
 */
export function getRedChannelStat<T>(value: T | T[] | null | undefined): T | null | undefined {
  if (value == null) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.length > 0 ? value[0] : undefined;
  }

  return value;
}
